import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PlanDispatchDialog } from "@/components/planning/PlanDispatchDialog";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate } from "@/lib/format";

// LM "Plan Dispatch": choose Part / Full dispatch, or open a draft plan to review and confirm
export function PlanDispatchStart({ order, onClose, onSaved }) {
  const { data } = useFetch(`/planned-dispatches?lm_id=${order.id}`);
  const [mode, setMode] = useState(null);
  const [draft, setDraft] = useState(null);
  const [pickDraft, setPickDraft] = useState(false);
  if (!data) return null;
  if (mode || draft) return <PlanDispatchDialog order={order} plan={draft} mode={mode} plans={data} onClose={() => { setMode(null); setDraft(null); }} onSaved={onSaved} />;
  const drafts = data.filter((p) => p.planning_status === "draft");
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl w-[95vw]" data-testid="plan-start-dialog">
        <DialogHeader><DialogTitle>Plan Dispatch · {order.order_no}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Part Dispatch: enter the quantity for this batch. Full Dispatch: every line is filled with its unplanned balance. Confirm draft: review a saved draft plan and confirm it.</p>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => setMode("part")} data-testid="plan-start-part-btn">Part Dispatch</Button>
          <Button variant="outline" onClick={() => setMode("full")} data-testid="plan-start-full-btn">Full Dispatch</Button>
          <Button variant="outline" disabled={!drafts.length} onClick={() => setPickDraft(true)} data-testid="plan-start-confirm-draft-btn">Confirm draft{drafts.length ? ` (${drafts.length})` : ""}</Button>
        </div>
        {!drafts.length && <p className="text-[11px] text-slate-500" data-testid="plan-start-no-drafts">No draft plans on this LM.</p>}
        {pickDraft && (
          <div className="space-y-1" data-testid="plan-start-draft-list">
            {drafts.map((p) => (
              <button key={p.id} className="flex w-full items-center justify-between rounded border border-slate-200 px-3 py-2 text-left text-xs hover:bg-slate-50" onClick={() => setDraft(p)} data-testid={`plan-start-draft-${p.planned_dispatch_number}`}>
                <span className="font-mono font-semibold">{p.planned_dispatch_number}</span>
                <span className="text-slate-500">{fmtDate(p.expected_dispatch_date)} · {p.lines.reduce((s, l) => s + (l.planned_dispatch_qty || 0), 0)} units</span>
              </button>
            ))}
          </div>
        )}
        <DialogFooter><Button variant="outline" onClick={onClose} data-testid="plan-start-cancel-btn">Cancel</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
